module.exports = __webpack_public_path__ + "img/landing_karateka.b469a97f.png";